/**
 * @file: weixin.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const useWeixinIntegration = () => {};
